module.exports = __webpack_public_path__ + "9779d9a1/img/question-icon.06c20c5d.svg";